import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { postCoreTimelineExportSlice } from './post';

export const coreTimelineExportReducers = combineReducers({
	post: postCoreTimelineExportSlice.asyncReducers
});

export const coreTimelineExportWatchers = combineAllWatchers([
	postCoreTimelineExportSlice.asyncWatchers
]);
